import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import React from 'react';

import { Panel } from '../../../../../components/atoms/Panel';

export interface SolutionSummary {
  solutionAction: string;
  count: number;
  percentage: number;
}

export interface CommonSolutionsPanelProps {
  solutions: SolutionSummary[];
  loading?: boolean;
  partTypeName?: string;
  totalJobs?: number;
}

export const CommonSolutionsPanel: React.FC<CommonSolutionsPanelProps> = ({
  solutions,
  loading,
  partTypeName,
  totalJobs = 0,
}) => {
  const title = partTypeName ? `Common Solutions — ${partTypeName}` : 'Common Solutions';

  return (
    <Panel title={title}>
      {loading ? (
        <Typography sx={{ fontSize: '13px', color: 'text.secondary', py: 1.5, textAlign: 'center' }}>
          Loading...
        </Typography>
      ) : solutions.length === 0 ? (
        <Typography sx={{ fontSize: '13px', color: 'text.secondary', py: 1.5, textAlign: 'center' }}>
          No solution data available for this part type
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {totalJobs > 0 && (
            <Typography sx={{ fontSize: '11px', color: 'text.secondary' }}>
              Based on {totalJobs} resolved job{totalJobs !== 1 ? 's' : ''}
            </Typography>
          )}
          {solutions.map((sol) => (
            <Box key={sol.solutionAction}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 0.5 }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
                  {sol.solutionAction}
                </Typography>
                <Typography sx={{ fontSize: '12px', color: 'text.secondary', flexShrink: 0, ml: 2 }}>
                  {sol.count} ({sol.percentage}%)
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={sol.percentage}
                sx={{
                  height: 6,
                  borderRadius: 3,
                  bgcolor: 'v4.tableEven',
                  '& .MuiLinearProgress-bar': {
                    borderRadius: 3,
                    bgcolor: 'v4.accent',
                  },
                }}
              />
            </Box>
          ))}
        </Box>
      )}
    </Panel>
  );
};
